import { useOutletContext } from "react-router-dom";
import { Hero } from "components/V3/Hero";
import { Helmet } from "react-helmet-async";
import { FamilyFocused } from "components/V3/FamilyFocused";
import { AreasWeProvide } from "components/V3/AreasWeProvide";

import { GetStartedSeeResults } from "components/V3/GetStartedSeeResults";
import { LicensedCareTeam } from "components/V3/LicensedCareTeam";
import { StoriesFromFamilies } from "components/V3/StoriesFromFamilies";
import { TrustedLicense } from "components/V3/TrustedLicense";
import { LicensedBy } from "components/V3/LicensedBy";
import { t } from "i18next";

const MainPage = () => {
  const { journeySectionRef, onPrimaryCtaClick } = useOutletContext() || {};
  return (
    <>
      <Helmet>
        <title>{t("siteMap.homePage.title")}</title>
        <meta name="description" content={t("siteMap.homePage.description")} />
      </Helmet>
      <Hero onPrimaryCtaClick={onPrimaryCtaClick} />
      <FamilyFocused />
      <AreasWeProvide />
      <GetStartedSeeResults journeySectionRef={journeySectionRef} />
      <LicensedCareTeam />
      <LicensedBy />
      <StoriesFromFamilies />
      <TrustedLicense />
    </>
  );
};

export default MainPage;
